import { createVanIconComponent } from "./van"

const Photo = createVanIconComponent("photo")
export default Photo
